<template>
  <v-dialog v-model="dialog" max-width="600" persistent class="pa-0">
    <v-card>
      <v-card-title>
        {{ $t("titleModalConfigFields") }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <!-- Coluna 1 -->
          <v-col cols="6">
            <v-col>
              <strong>{{ $t("titleModalConfigFieldsColumnOne") }}</strong>
            </v-col>
            <v-checkbox
              v-for="field in fields"
              :key="field.value"
              v-model="field.selected"
              :label="field.text"
            ></v-checkbox>
          </v-col>

          <!-- Coluna 2: Campos Adicionais Dinâmicos -->
          <v-col v-if="additionalFields.length > 0" cols="6">
            <v-col>
              <strong>{{ $t("titleModalConfigFieldsColumnTwo") }}</strong>
            </v-col>
            <v-col>
              <span>{{ regTypeCodeName }}</span>
            </v-col>
            <v-checkbox
              v-for="field in additionalFields"
              :key="field.value"
              v-model="field.selected"
              :label="field.text"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cancel">{{ $t("cancel") }}</v-btn>
        <v-btn @click="confirm" color="primary">{{ $t("confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["config", "regFieldsArray", "items"],
  data() {
    return {
      dialog: true,
      fields: [
        {
          text: this.$t("components.regEdit.headers.date"),
          value: "date",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.regType"),
          value: "regTypeDescription",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.job"),
          value: "jobCode",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.description"),
          value: "jobDescription",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.resource"),
          value: "resourceDescription",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.codAccount"),
          value: "resourceCode",
          selected: false,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.desAccount"),
          value: "environmentDescription",
          selected: false,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.codItem"),
          value: "jobItemCode",
          selected: false,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.descItem"),
          value: "jobItemDescription",
          selected: false,
          order: 1,
        },
        {
          text: this.$t("components.regEdit.headers.user"),
          value: "user",
          selected: true,
          order: 1,
        },
        {
          text: this.$t("table.actions"),
          value: "action",
          align: "right",
          selected: true,
          order: 9999,
        },
      ],
      additionalFields: [],
    };
  },
  computed: {
    regTypeCodeName() {
      if (this.items && this.items.length > 0) {
        return this.items[0].regTypeDescription;
      } else {
        return "";
      }
    },
  },
  methods: {
    confirm() {
      const selectedFields = this.fields
        .concat(this.additionalFields)
        .sort((a, b) => a.order - b.order)
        .filter((field) => field.selected);

      this.saveSelectedFields(selectedFields);
      this.$emit("config-fields-selected", selectedFields);
      this.dialog = false;
      this.$emit("close-config-modal");
    },
    cancel() {
      this.dialog = false;
      this.$emit("close-config-modal");
    },
    saveSelectedFields(fields) {
      localStorage.setItem("selectedFields", JSON.stringify(fields));
    },
    loadSelectedFields() {
      const storedFields = localStorage.getItem("selectedFields");
      if (storedFields) {
        const parsedFields = JSON.parse(storedFields);

        this.fields.forEach((field) => {
          field.selected = parsedFields.some(
            (selectedField) =>
              selectedField.value === field.value ||
              selectedField.text === field.text
          );
        });

        this.additionalFields.forEach((field) => {
          field.selected = parsedFields.some(
            (selectedField) =>
              selectedField.value === field.value ||
              selectedField.text === field.text
          );
        });
      }
    },
    async openConfigModalWithRegFieldsArray() {
      const storedRegFieldsArrayString = localStorage.getItem("regFieldsArray");

      if (storedRegFieldsArrayString) {
        const regFieldsArray = JSON.parse(storedRegFieldsArrayString);

        this.configModalVisible = true;

        this.localRegFieldsArray = [...regFieldsArray];

        await this.$nextTick();

        this.additionalFields = this.localRegFieldsArray.map(
          (regField, index) => {
            const foundField = regField.regFieldId ? regField : null;

            return {
              text: foundField
                ? foundField.regTypeField.label
                : `Field ${index + 1}`,
              value: `regFields[${index}].value`,
              selected: false,
              order: 1,
              addFields: true,
            };
          }
        );

        this.loadSelectedFields();

        this.$emit("config-fields-additional", this.localRegFieldsArray);
      } else {
        this.additionalFields = [];
      }
    },
  },
  mounted() {
    this.loadSelectedFields();
    this.openConfigModalWithRegFieldsArray();
  },
};
</script>
